// Shared onboarding typography + controls. One system across all four screens.

export const OnbEyebrow = ({ children, testId, tight = false }) => (
  <span
    className={`block uppercase text-[#D4A843]/85 font-medium ${
      tight
        ? 'text-[9px] tracking-[0.22em] lg:text-[12px] lg:tracking-[0.3em] xl:text-[13px]'
        : 'text-[9.5px] tracking-[0.3em] lg:text-[12px] lg:tracking-[0.36em] xl:text-[13px]'
    }`}
    style={{ fontFamily: 'var(--font-display)' }}
    data-testid={testId}
  >
    {children}
  </span>
);

export const OnbHeadline = ({ children, testId, className = '' }) => (
  <h1
    className={`mt-4 lg:mt-6 xl:mt-7 text-[1.6rem] lg:text-[2.95rem] xl:text-[3.9rem] 2xl:text-[4.2rem] leading-[1.28] lg:leading-[1.1] xl:leading-[1.08] tracking-[-0.015em] lg:tracking-[-0.02em] text-white/95 text-balance ${className}`}
    style={{ fontFamily: '"Cormorant Garamond", Georgia, serif', fontWeight: 300 }}
    data-testid={testId}
  >
    {children}
  </h1>
);

export const OnbBody = ({ children, testId, className = '' }) => (
  <p
    className={`text-[0.82rem] lg:text-[1.02rem] xl:text-[1.18rem] leading-[1.75] lg:leading-[1.7] text-white/65 ${className}`}
    style={{ fontFamily: 'var(--font-display)' }}
    data-testid={testId}
  >
    {children}
  </p>
);

export const OnbButton = ({ children, onClick, disabled, testId, type = 'button' }) => (
  <button
    type={type}
    onClick={onClick}
    disabled={disabled}
    className="rounded-full bg-[#EDE4D2] px-9 py-3.5 lg:px-12 lg:py-5 text-[0.82rem] lg:text-[1.02rem] font-medium tracking-[0.02em] whitespace-nowrap text-[#0A0A12] transition-colors duration-300 hover:bg-white focus:outline-none focus-visible:ring-2 focus-visible:ring-[#F0C987] focus-visible:ring-offset-2 focus-visible:ring-offset-[#05070f] disabled:opacity-40"
    style={{ fontFamily: 'var(--font-display)' }}
    data-testid={testId}
  >
    {children}
  </button>
);

export const OnbGhostButton = ({ children, onClick, testId }) => (
  <button
    type="button"
    onClick={onClick}
    className="rounded-full border border-white/15 px-6 py-3.5 lg:px-9 lg:py-5 text-[0.8rem] lg:text-[1.02rem] text-white/55 transition-colors duration-300 hover:text-white/85 hover:border-white/30 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#F0C987] focus-visible:ring-offset-2 focus-visible:ring-offset-[#05070f]"
    style={{ fontFamily: 'var(--font-display)' }}
    data-testid={testId}
  >
    {children}
  </button>
);

export const OnbError = ({ children, testId }) => (
  <p
    className="mt-4 text-[0.78rem] leading-relaxed text-[#F0B5A0]"
    style={{ fontFamily: 'var(--font-display)' }}
    role="alert"
    data-testid={testId}
  >
    {children}
  </p>
);
